// Routes — pilotage d'une organisation (projets, groupes, séances, bibliothèques, réglages d'org).
// Lot 7.6 (2026-10-17) : App.tsx éclaté par domaine, enfants de <Routes> recopiés
// tels quels (ordre et commentaires), aucune URL changée ; rendu en fragment dans
// l'ordre d'origine par App.tsx.
import { lazy, Suspense } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { LoadingFallback } from "./communs";

// Lot 9.0 (2026-10-18) : /dashboard, /projets/calendrier et l'ancienne page
// séance Inter (/plateforme/groupes/:g/seances/:s) sont redirigés par LA table
// routes/redirections.ts — plus de redirection écrite à la main ici.
// Pages protégées (lazy loaded)
// Lot 9.5 (2026-10-18) : les pages à onglets — Projets (« les miens / tous »),
// Animateurs (annuaire, pool, certifications, lettres, disponibilités),
// Bibliothèque (six familles + tarifs + savoir métier), Programmation (module
// de l'org marketplace : pipeline + axes). Les pages qu'elles coiffent sont
// chargées par chaque coquille ; leurs anciennes adresses sont des entrées de
// routes/redirections.ts.
export const ProjetsHubPage = lazy(() => import("../pages/projets/ProjetsHubPage"));
export const AnimateursHubPage = lazy(() => import("../pages/animateurs/AnimateursHubPage"));
export const BibliothequePage = lazy(() => import("../pages/bibliotheque/BibliothequePage"));
export const ProgrammationPage = lazy(() => import("../pages/programmation/ProgrammationPage"));
export const ProjetFormPage = lazy(() => import("../pages/ProjetFormPage"));
export const ProjetDetailPage = lazy(() => import("../pages/ProjetDetailPage"));
export const ProduitPanel = lazy(() => import("../pages/projet/ProduitPanel"));

export const GroupeFormPage = lazy(() => import("../pages/GroupeFormPage"));
export const GenererSeancesPage = lazy(() => import("../pages/GenererSeancesPage"));
export const SeanceDetailPage = lazy(() => import("../pages/SeanceDetailPage"));
export const ParticipantsPage = lazy(() => import("../pages/ParticipantsPage"));
export const OrganisationParametresPage = lazy(() => import("../pages/OrganisationParametresPage"));
export const SallesPage = lazy(() => import("../pages/SallesPage"));
export const OrganisationAutomatisationsPage = lazy(() => import("../pages/OrganisationAutomatisationsPage"));
export const MesureImpactPage = lazy(() => import("../pages/MesureImpactPage"));
export const CockpitReglagesPage = lazy(() => import("../pages/CockpitReglagesPage"));
export const EquipeRolesPage = lazy(() => import("../pages/EquipeRolesPage"));
export const ResultatsImpactPage = lazy(() => import("../pages/ResultatsImpactPage"));
export const TableauDeBordImpactPage = lazy(() => import("../pages/TableauDeBordImpactPage"));
export const ExportsPage = lazy(() => import("../pages/ExportsPage"));
export const BpfPage = lazy(() => import("../pages/BpfPage"));
// Lot 9.4 (2026-10-18) : LA fiche d'une inscription, détachée du tiroir de LA
// page groupe (D4) — niveau organisation (l'org du groupe), lue sous la règle
// de lecture du groupe (pilote de l'org, admin plateforme, équipe).
export const InscriptionPage = lazy(() => import("../pages/InscriptionPage"));
export function routesPilotage() {
  return (
    <>
      <Route
        path="/o/:slug/inscriptions/:id"
        element={
          <ProtectedRoute requiredRoles={["ANIMATEUR", "SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <InscriptionPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
{/* Protected routes — Pilotage (SUPER_ADMIN + PILOTE) */}
      <Route
        path="/o/:slug/projets"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <ProjetsHubPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/projets/nouveau"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <ProjetFormPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/projets/:id/edit"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <ProjetFormPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/projets/:projetId/impact/tableau-de-bord"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <TableauDeBordImpactPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/projets/:projetId/produits/:produitId/*"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <ProduitPanel />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/projets/:id/*"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <ProjetDetailPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/projets/:projetId/groupes/nouveau"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <GroupeFormPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/projets/:projetId/groupes/:groupeId/edit"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <GroupeFormPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {/* La page d'un groupe Intra n'habite plus le projet (lot 9.2c) : LA page
          groupe est /o/:slug/groupes/:id (routes/publiques.tsx) ; les adresses
          /o/:slug/projets/:p[/produits/:pp]/groupes/:g[/onglet] sont des entrées
          de routes/redirections.ts. Restent ici le formulaire, la planification
          et la page Séance (hiérarchie projet jusqu'au palier 9.3). */}
      <Route
        path="/o/:slug/projets/:projetId/groupes/:groupeId/generer-seances"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <GenererSeancesPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {/* LA page Séance (bloc 8.B ; lot 9.3 : UNE adresse pour les deux modes,
          modèle §8.2) — les formes hiérarchiques /o/:slug/projets/:p[/produits/
          :pp]/groupes/:g/seances/:s sont des entrées de routes/redirections.ts.
          Animateurs autorisés (ils animent les séances). */}
      <Route
        path="/o/:slug/groupes/:groupeId/seances/:seanceId"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE", "ANIMATEUR"]}>
            <Suspense fallback={<LoadingFallback />}>
              <SeanceDetailPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/animateurs"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <AnimateursHubPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/participants"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <ParticipantsPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/parametres"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <OrganisationParametresPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {/* Lot L (2026-10-27) : salles de l'organisation, blocages, planning hebdomadaire. */}
      <Route
        path="/o/:slug/salles"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <SallesPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/cockpit-reglages"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <CockpitReglagesPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/equipe"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <EquipeRolesPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/bpf"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <BpfPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {/* Lot 9.5 : LA Bibliothèque (six familles héritables + tarifs + savoir
          métier) — ses anciennes adresses /o/:slug/bibliotheque/<famille> sont
          des entrées de routes/redirections.ts. */}
      <Route
        path="/o/:slug/bibliotheque"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <BibliothequePage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {/* Lot 9.5 : la Programmation est un module de l'org marketplace (modèle
          §8.3) — pipeline + axes ; ex-/plateforme/pipeline et
          /plateforme/pool-animateurs (table des redirections). Orgs plateforme
          seulement, comme les anciennes routes. */}
      <Route
        path="/o/:slug/programmation"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]} orgPlateformeOnly>
            <Suspense fallback={<LoadingFallback />}>
              <ProgrammationPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/projets/mesure-impact"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <MesureImpactPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/impact/resultats/:campagneId"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <ResultatsImpactPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      {/* Centre de réglage des automatisations (Phase 2, 2026-08-05) —
          l'URL de l'ancienne page supprimée reprend du service : réglages
          org éditables + état par produit (même dialog ⚡ que le
          catalogue) + dérogations par projet + renvoi Inter. */}
      <Route
        path="/o/:slug/automatisations"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <OrganisationAutomatisationsPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
      <Route
        path="/o/:slug/projets/exports"
        element={
          <ProtectedRoute requiredRoles={["SUPER_ADMIN", "PILOTE"]}>
            <Suspense fallback={<LoadingFallback />}>
              <ExportsPage />
            </Suspense>
          </ProtectedRoute>
        }
      />
    </>
  );
}
